<template>
  <v-container justify-start fluid>  
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs4 ml-5>
            <v-text-field label="Wyszukaj po Imię/Nazwisko/PESEL" v-model="searchTerm" @keydown.enter="doSearch"></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-btn color="success" @click="doSearch">Szukaj</v-btn>    
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>        
        <v-btn color="info" @click="addNew"  v-if="$can('do','POKO_Klienci_Edycja')" style="float:right">Dodaj pacjenta</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table              
              :options.sync="pagination"
              :items="items"
              :loading="loading"                        
              :server-items-length="totalResults"              
              :footer-props="{
                        itemsPerPageOptions:[20,50,100,200],                        
              }"  
              :headers="headers">
                <template v-slot:item.id="{item}">
                    <v-layout align-center>
                      <v-icon small class="mr-2" @click="editClient(item.id)" title="Edytuj" v-if="$can('do','POKO_Klienci_Edycja')">fa-edit</v-icon>
                      <v-icon small class="mr-2"  @click="deleteClient(item.id)" title="Usuń" v-if="$can('do','POKO_Klienci_Usuwanie')">fa-trash-alt</v-icon>
                      <v-icon small class="mr-2"  @click="showPrescriptions(item.id)" title="Recepty" v-if="recepty" color="red">fa-file-prescription</v-icon>
                    </v-layout>                  
                </template>
                <template v-slot:item.creationTime="{item}">
                  {{ formatDate(item.creationTime) }}
                </template>
        </v-data-table>          
      </v-flex>
    </v-layout>          
  <AddEditClient v-if="showAddClient" :visible="showAddClient" :id="selectedClientId" @close="closeAddPopup" />
  <ReceptyDialog v-if="showRecepty" :visible="showRecepty" :clientid="selectedClientId" :visitid="0" :therapistid="this.userdetails.id"  @close="closeRecepty" />
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { clientService } from "@/services/";
import swal from "sweetalert";
import AddEditClient from "./AddEditClient";
import * as dayjs from "dayjs";
import ReceptyDialog from "@/components/clients/ReceptyDialog.vue";
import { ability } from "@/store/ability";
export default {
  name: "Clients",
  data() {
    return {
      loading: true,
      showAddClient: false,
      selectedClientId: 0,
      totalResults: 0,
      items: [],      
      pagination: {},
      showRecepty: false,
      searchTerm: '',      
      headers: [
        { text: 'Imię', sortable: true, align: 'left', value: 'name'},
        { text: 'Nazwisko', sortable: true, align: 'left', value: 'surname'},
        { text: 'Opis', sortable: false, align: 'left', value: 'description'},
        { text: 'Telefon', sortable: true, align: 'left', value: 'phone'},
        { text: 'Miasto', sortable: true, align: 'left', value: 'city'},
        { text: 'Data dodania', sortable: true, align: 'left', value: 'creationTime'},
        { text: 'PESEL', sortable: true,align: 'left', value: 'pesel'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}

      ]          
    }
  },
  computed: {
    ...mapState('account', ['userdetails']),
    recepty: function() {
      return this.userdetails != null && ( (this.userdetails.therapistDetails != null && this.userdetails.therapistDetails.recepty && this.userdetails.therapistDetails.czyCertyfikatWgrany) || ( ability.can('do','POKO_SystemAdmin')));
    }
  },
  components: {ReceptyDialog, AddEditClient},
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    addNew() {
      this.selectedClientId = 0
      this.showAddClient = true
    },
    editClient(id) {
       this.selectedClientId = id
       this.showAddClient = true
    },
    doSearch()
    {
      this.refreshTable();
    },
    showPrescriptions(id)
    {
      this.selectedClientId = id
      this.showRecepty = true
    },
    closeRecepty()
    {
      this.showRecepty = false
      this.selectedClientId = 0
    },
    deleteClient(id) {
      swal({
        title: "Czy na pewno?",
        text:
          "Usuniecię pacjenta, spowoduje wyczyszczenie jego wrażliwych danych i dodanie go do usuniętych pacjentów!",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          clientService
            .deleteClient(id)
            .then(resp => {
              if (resp.data == null || !resp.data.success) {
                throw "Błąd usuwania pacjenta";
              } else {
                this.success("Usunięto");
                this.refreshTable();
              }
            })
            .catch(e => {
              console.log(e);
              // Extract error message from ABP UserFriendlyException
              let errorMessage = "Nie można usunąć pacjenta";
              if (e.response && e.response.data && e.response.data.error) {
                const error = e.response.data.error;
                if (error.details) {
                  errorMessage = error.details;
                } else if (error.message) {
                  errorMessage = error.message;
                }
              }
              swal({
                title: "Nie można usunąć pacjenta",
                text: errorMessage,
                icon: "error",
                button: "OK"
              });
            });
        }
      });
    },
    closeAddPopup() {
      this.showAddClient = false
      this.selectedClientId = 0
      this.refreshTable()
    },
    refreshTable()
    {
          this.loading = true

          this.requestClients().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
    },
    requestClients() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      var req = clientService.getAll({ query: this.searchTerm, page: page, limit: itemsPerPage, sorting: sortValue });
      return req.catch(()=> {
        this.error("Błąd pobierania pacjentów");
      });                  
    },
    formatDate(val)
    {
      let dj = dayjs(val)
      if(dj != null)
      {
        return dj.format("DD-MM-YYYY HH:mm")
      }
      else
      {
        return val
      }
    }
  },
  created() {
    this.updateTitle("Pacjenci");
    // Check for editId query param to open client editor directly
    if (this.$route.query.editId) {
      this.selectedClientId = parseInt(this.$route.query.editId);
      this.showAddClient = true;
      // Clean up the URL
      this.$router.replace({ path: "/clients" });
    }
  },
  watch: {
      pagination: {
        handler() {
          this.requestClients().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
        },
        deep: true
      }
  }  
};
</script>

<style>
</style>
